AuthRoute = require 'mixins/authenticated-route'

App.OrdersMapRoute = Em.Route.extend AuthRoute,
  realTimeService: Em.inject.service('realTime')

  setupController: (controller) ->
    ordersController = @controllerFor('orders')

    category = ordersController?.get('selectedOrdersCategory')

    if not Em.isEmpty('category') and not (category in [ 'current', 'delayed' ])
      ordersController.set('selectedOrdersCategory', 'current')

    @_super(arguments...)

  renderTemplate: (controller, model) ->
    @render 'orders.map.sidebar',
      outlet: 'sidebar',
      controller: controller

    @render 'orders.map.content',
      controller: controller
